import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErrorComponent } from './error.component';
import { IconsModule } from '../icons/icons.module';
import { AlertsComponent } from './alerts.component';
import { SuccessComponent } from './success.component';
import { TransitionsModule } from '../transitions/transitions.module';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { AlertsConfig } from 'config/alerts.config';
import { AlertMessagesConfig } from 'config/alert-messages.config';
import { AlertComponent } from './alert.component';

@NgModule({
  imports: [
    CommonModule,
    IconsModule,
    TransitionsModule,
  ],
  declarations: [
    ErrorComponent,
    SuccessComponent,
    AlertsComponent,
    AlertComponent,
  ],
  exports: [
    AlertsComponent,
  ],
  providers: [
    AlertsService,
    AlertsConfig,
    AlertMessagesConfig,
  ]
})
export class AlertsModule { }
